<template>
    <Fragment>
        <div class="radio-group" @click="onChangePaymentRadio">
            <div class="radio-heading">
                <span class="radio-conteiner">
                    <input
                        type="radio"
                        name="payment_radio"
                        :value="payment_data"
                        v-model="payment_selected"
                        @change="onChangePaymentRadio($event)"
                    >
                </span>
                <span class="forma-conteiner">
                    <i class="fas fa-credit-card"></i>
                    Cartão de crédito
                </span>
            </div>
        </div>
        <div class="content-payment">
                <div v-if="payment_selected && payment_data.id == payment_selected.id">
                    <!--NUMBER CARD-->
                    <div class="form-group required-field">
                        <label for="numberCardIpag">Número do Cartão de Crédito</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="numberCardIpag"
                            name="numberCardIpag"
                            :value="number"
                            @input="$emit('update:number', $event.target.value)"
                        />
                        <div v-if="validate.formIpagCard.number.$error && !validate.formIpagCard.number.required" class="required">* Obrigatório</div>
                        <div v-if="!cardValid" class="required">Não aceitamos esta bandeira de cartão</div>
                    </div>
                    <!--END NUMBER CARD-->
                    <!--HOLDER CARD-->
                    <div class="form-group required-field">
                        <label for="holderCardIpag">Titular do cartão</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="holderCardIpag"
                            name="holderCardIpag"
                            v-uppercase
                            :value="holder"
                            @input="$emit('update:holder', $event.target.value)"
                        />
                        <div v-if="validate.formIpagCard.holder.$error && !validate.formIpagCard.holder.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END HOLDER CARD-->

                    <!--BRAND CARD-->
                    <div class="form-group required-field">
                        <label for="brandCardIpag">Bandeira do cartão</label>
                        <select
                            class="form-payment"
                            @input="$emit('update:method', $event.target.value)"
                        >
                            <option value="" selected>Selecione a bandeira</option>
                            <option v-for="item in payment_data.payment_method" :key="item.id" :value="item.method">{{item.method}}</option>
                        </select>
                        <div v-if="validate.formIpagCard.method.$error && !validate.formIpagCard.method.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END BRAND CARD-->

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group required-field mb-0">
                                <label>Vencimento do cartão</label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group required-field mb-0">
                                <label>Cvv</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <!--EXPIRY MONTH-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_month', $event.target.value)"
                            >
                                <option value="" selected>Mês</option>
                                <option v-for="count in 12" :key="count" :value="count < 10 ? '0'+count : count">{{ count < 10 ? '0'+count : count }}</option>
                            </select>
                            <div v-if="validate.formIpagCard.expiry_month.$error && !validate.formIpagCard.expiry_month.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY MONTH-->

                        <!--EXPIRY YEAR-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_year', $event.target.value)"
                            >
                                <option value="" selected>Ano</option>
                                <option v-for="(n, $index) in 12" :key="n" :value="$index + countDate">{{$index + countDate}}</option>
                            </select>
                            <div v-if="validate.formIpagCard.expiry_year.$error && !validate.formIpagCard.expiry_year.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY YEAR-->

                        <!--CVV CARD-->
                        <div class="col-md-4">
                            <input
                                type="text"
                                class="form-payment"
                                id="cvvIpag"
                                name="cvvIpag"
                                :max-length="maxlengthCvv"
                                placeholder="cvv"
                                @input="$emit('update:cvv', $event.target.value)"
                            />
                            <div
                                v-if="validate.formIpagCard.cvv.$error && !validate.formIpagCard.cvv.required"
                                class="required"
                            >
                                * Obrigatório
                            </div>
                        </div>
                        <!--END CVV CARD-->
                    </div>

                    <!--INSTALLMENTS-->
                    <div class="form-group required-field">
                        <label for="installments_ipag">Parcelas</label>
                         <select class="form-payment" @input="$emit('update:installment', $event.target.value)">
                            <option v-for="i in 10" :key="i" :value="i" :selected="i == 1">
                                {{
                                    i == 1
                                    ? "à vista - "+currency.money(totalAmount / i)
                                    : i+"x de "+currency.money(totalAmount / i)+" sem juros"
                                }}
                            </option>
                        </select>
                        <div v-if="validate.formIpagCard.installment.$error && !validate.formIpagCard.installment.required" class="required">* Selecione uma parcela</div>
                    </div>
                    <!--END INSTALLMENTS-->
                </div>
        </div>
    </Fragment>
</template>

<script>
import {Fragment}  from 'vue-fragment'
import {mapState, mapActions} from 'vuex'
import Currency from '../../helpers/parseCurrency'

export default {
    name: 'Ipag',
     directives: {
        "uppercase": {
            update: function (el) {
                el.value = el.value.toUpperCase()
            }
        }
    },
    props: {
        //numero de parcelas sem juros definido pela empresa no painel administrativo
        interest_free_installments: {
            default: 0
        },
        payment_data: {
            required: true,
            default: Object,
            type: Object
        },
        payment_selected: {
            default: Object,
            type: Object
        },
        holder: {
            default: ''
        },
        method: {
            default: '',
        },
        number: {
            default: ''
        },
        expiry_month: {
            default: ''
        },
        expiry_year: {
            default: ''
        },
        cvv: {
            default: ''
        },
        installment: {
            default: ''
        },
        validate: {
            required: true
        }
    },
    components: {
        Fragment
    },
    data() {
        return {
            maxlengthCvv: 3,
            installments: 10,
            disabledInstallments: true,
            countDate: 0,
            currency: Currency,
            cardValid: true
        }
    },
    created() {
        this.countDate = new Date().getFullYear()
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemsCart"
        ]),
        onChangeInstallment(event)
        {
            let selected = event.target.value.split(';')
            let itemsCart = this.itemsCart
            itemsCart.totalAmount = selected[2]
            this.ActionSetItemsCart(itemsCart)
        },
        onChangePaymentRadio()
        {
            this.$emit('onChangePayment', this.payment_data)
        },
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        totalAmount() {
            return this.itemsCart.totalAmount.toFixed(2)
        }
    }
}
</script>
